export const ATTRIBUTE_FILTER_PARAM = 'attr';
export const ROLE_FILTER_PARAM = 'role';
